import { LoaderFunction } from 'react-router-dom';
import { isFeatureFlagOn } from '../../feature-flags/utils';
import { PipelineRunModel } from '../../models';
import { GithubRedirectRouteParams } from '../../routes/utils';
import { QueryPipelineRun, QueryPipelineRunWithKubearchive } from '../../utils/pipelinerun-utils';
import { checkReviewAccesses } from '../../utils/rbac';

export const githubRedirectLoader: LoaderFunction = async ({ params }) => {
  const namespace = params[GithubRedirectRouteParams.ns];
  const pipelineRunName = params[GithubRedirectRouteParams.pipelineRunName];
  const allowed = await checkReviewAccesses(
    {
      model: PipelineRunModel,
      verb: 'get',
    },
    namespace,
  );
  if (!allowed) throw new Response('Access check Denied', { status: 403 });
  if (!pipelineRunName) return null;

  if (isFeatureFlagOn('pipelineruns-kubearchive')) {
    return QueryPipelineRunWithKubearchive(namespace, pipelineRunName);
  }

  return QueryPipelineRun(namespace, pipelineRunName);
};

export { default as GithubRedirect } from './GithubRedirect';
